import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { Menu as MuiMenu } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { ReactComponent as BurgerlIcon } from './images/burger.svg';
import Tooltip from '@mui/material/Tooltip';
import css from './Menu.module.scss';

type TMenu = {
  children: React.ReactNode;
};

export const Menu = ({ children }: TMenu) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title="Account settings">
          <IconButton
            className={css.icon}
            onClick={handleClick}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            disableRipple
            disableTouchRipple
            disableFocusRipple
          >
            <BurgerlIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <MuiMenu
        // @ts-ignore
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              width: '287px',
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {children}
      </MuiMenu>
    </>
  );
};
